import { DELIVERY_STATUSES } from '../../utils/catalogs';

/*
 * Reading a webhook's status against the delivery catalog, and the rule that
 * makes a combination unique.
 */

const findStatus = (systemName) =>
  DELIVERY_STATUSES.find((status) => status.system_name === systemName);

export const getStatusLabel = (systemName) => findStatus(systemName)?.user_name || systemName;

export const getSubstatuses = (statusName) => findStatus(statusName)?.substatus || [];

export const getSubstatusLabel = (statusName, systemName) =>
  getSubstatuses(statusName).find((substatus) => substatus.system_name === systemName)
    ?.user_name || systemName;

export const STATUS_OPTIONS = DELIVERY_STATUSES.map((status) => ({
  value: status.system_name,
  label: status.user_name,
}));

/** A status of the catalog with one of its own substatuses. */
export const isValidStatusPair = (status, substatus) =>
  Boolean(status && substatus) &&
  getSubstatuses(status).some((item) => item.system_name === substatus);

/**
 * The webhook already set for a status and substatus, if any.
 *
 * The backend fires one with `.get(status, substatus, setting)`, an exact match:
 * "No aplica" is a substatus of its own, not a wildcard, and a second webhook
 * for the same pair makes that lookup fail — nothing is sent at all. Creating
 * refuses a duplicate; editing does not check, which is why the pair cannot be
 * changed once saved.
 *
 * @param {Array<object>} webhooks
 * @param {string} status
 * @param {string} substatus
 * @returns {object|null}
 */
export const findWebhookFor = (webhooks, status, substatus) =>
  webhooks.find((webhook) => webhook.status === status && webhook.substatus === substatus) || null;
